/** Step 1 (shared): what the experiment tests, as its name and description. */

import { Field } from "@/components/ui/field";
import type { NewExperiment } from "./use-new-experiment";

export function StepName({ flow }: { flow: NewExperiment }) {
  const { form } = flow;
  return (
    <>
      <Field
        label="What are you testing?"
        required
        htmlFor="ne-name"
        hint="This becomes the experiment's name, so the list says what changed."
      >
        <input
          id="ne-name"
          className="inp w-full"
          value={form.name}
          placeholder="e.g. v7: stricter dosage rule"
          onChange={(e) => form.setName(e.target.value)}
        />
      </Field>
      <Field label="Description" htmlFor="ne-description" optional hint="Why you are running it.">
        <textarea
          id="ne-description"
          rows={3}
          className="inp h-auto w-full py-2"
          value={form.description}
          placeholder="e.g. Checks the new dosage rule does not drop valid cases."
          onChange={(e) => form.setDescription(e.target.value)}
        />
      </Field>
    </>
  );
}
